import React from "react"
import styled from "styled-components"
import { FaCheck } from "react-icons/fa"
import { StaticImage } from "gatsby-plugin-image"

const Information = () => {
  return (
    <Container>
      <div className="section section-center">
        <Title>Te ayudamos en lo que necesites</Title>
        <article className="info-center">
          <li>
            <StaticImage
              src="../assets/images/devaluation.png"
              layout="fixed"
              width={135}
              height={135}
              placeholder="blurred"
              alt="devaluation icon"
            />
            <p>Económicos</p>
          </li>
          <li>
            <StaticImage
              src="../assets/images/teamwork.png"
              layout="fixed"
              width={135}
              height={135}
              placeholder="blurred"
              alt="teamwork icon"
            />
            <p>Seguros CDW Y DAT</p>
          </li>
          <li>
            <StaticImage
              src="../assets/images/insurance.png"
              layout="fixed"
              width={135}
              height={135}
              placeholder="blurred"
              alt="insurance icon"
            />
            <p>Personalizado</p>
          </li>
          <li>
            <StaticImage
              src="../assets/images/clock.png"
              layout="fixed"
              width={135}
              height={135}
              placeholder="blurred"
              alt="clock icon"
            />
            <p>Responsables</p>
          </li>
        </article>
        <article className="cards-center">
          <div className="card">
            <h2>Permiso internacional</h2>
            <p>
              Gestionamos en pocos minutos la autorización para cruzar en auto
              desde Chile a Argentina.
            </p>
            <span>
              <FaCheck />
            </span>
          </div>
          <div className="card">
            <h2>Entrega y retiro de vehículo a domicilio</h2>
            <p>
              Servicio de entrega y retiro de auto desde cualquier lugar de
              Puerto Montt o Puerto Varas.
            </p>
            <span>
              <FaCheck />
            </span>
          </div>
          <div className="card">
            <h2>Asistencia 24/7</h2>
            <p>
              Ofrecemos servicio de grúa las 24 hrs de lunes a domingo, dentro
              de Chile continental e Isla Grande de Chiloé.
            </p>
            <span>
              <FaCheck />
            </span>
          </div>
          <div className="card">
            <h2>Kilómetros libres</h2>
            <p>
              Si necesitas un vehículo para viajar largas distancias, nosotros
              te entregamos kilometraje libre en todos nuestros vehículos.
            </p>
            <span>
              <FaCheck />
            </span>
          </div>
        </article>
      </div>
    </Container>
  )
}

export default Information

const Container = styled.section`
  background: var(--grey-100);

  .info-center {
    margin-top: 3rem;
    flex-wrap: wrap;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
    li {
      margin: 0 auto;
    }
    p {
      text-align: center;
    }
    p:nth-child(2) {
      margin-left: -10px;
    }
  }

  .cards-center {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    margin-top: 30px;
  }

  .card {
    border-radius: var(--borderRadius);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 1.25rem 0.2rem;
    height: 315px;
    width: 265px;
    margin: 0.25rem;

    h2 {
      padding: 10px 0;
      letter-spacing: 1.6px;
      font-weight: 700;
      font-size: 20px;
      color: white;
      max-width: 220px;
    }
    p {
      color: white;
      margin: 0;
      font-size: 17px;
      line-height: 21px;
      max-width: 200px;
    }
    &:nth-child(1) {
      background: rgb(242 191 93);
    }
    &:nth-child(2) {
      background: rgb(246 97 97);
    }
    &:nth-child(3) {
      background: #536eb7;
    }
    &:nth-child(4) {
      background: #75cba8;
    }
    span {
      padding-top: 35px;
      padding-bottom: 15px;
      svg {
        font-size: 18px;
      }
    }
  }

  @media screen and (max-width: 568px) {
    .card {
      width: 310px;
    }
  }
`

const Title = styled.h2`
  text-align: center;
  text-transform: uppercase;
  &:after {
    content: "";
    background: #ff9800;
    display: block;
    height: 5px;
    width: 150px;
    margin: 30px auto 20px;
    @media (min-width: 768px) {
      width: 350px;
    }
  }
`
